import { useState } from "react";

import { useAppState } from "../../contexts/App";
import { api } from "../../services/api";
import { ERR_FREE_SITES_LIMIT_REACHED, isApiError } from "../../services/api/errors";

/**
 * Activates/deactivates the Keepo being edited. Reactivating a FREE Keepo counts against
 * the free Keepos limit (enforced by the server): when it is refused, the Keepo stays
 * deactivated and `showActivateLimitModal` flags that the limit modal should be shown.
 */
export const useToggleSiteActive = () => {
  const { appState, setAppState } = useAppState();

  const [isTogglingActive, setTogglingActive] = useState(false);
  const [showActivateLimitModal, setShowActivateLimitModal] = useState(false);

  const isActive = !appState.editingSiteDisabled;

  const toggleActive = async (active: boolean) => {
    if (isTogglingActive) {
      return;
    }
    setTogglingActive(true);

    try {
      const siteId = appState.editingSiteId as string;
      await (active ? api.enableSite(siteId) : api.disableSite(siteId));
      setAppState({ ...appState, editingSiteDisabled: !active });
    } catch (e) {
      if (active && isApiError(e, ERR_FREE_SITES_LIMIT_REACHED)) {
        setShowActivateLimitModal(true);
      }
    } finally {
      setTogglingActive(false);
    }
  };

  return {
    isActive,
    isTogglingActive,
    toggleActive,
    showActivateLimitModal,
    closeActivateLimitModal: () => setShowActivateLimitModal(false),
  };
};
